module.exports = __webpack_public_path__ + "img/destination-9.d0a78676.svg";